export const BRUSH = 'brush';
export const HIGHLIGHT = 'highlight';
export const TOOLTIP = 'tooltip';
export const FILTER = 'filter';
export const SELECT = 'select';

